module.exports = __webpack_public_path__ + "img/mp_qr.9dc700e9.jpg";